import { render, staticRenderFns } from "./OauthPage.vue?vue&type=template&id=4841b031"
import script from "./OauthPage.vue?vue&type=script&lang=js"
export * from "./OauthPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports